<template>
  <BaseTemplate app-name="RIS System" page-title="">
    <template #content>
      <div
        class="h-screen flex flex-col bg-gray-50 dark:bg-gray-900 text-gray-800 dark:text-gray-100 transition-colors duration-200">
        <!-- Main Content -->
        <div class="flex-1 flex overflow-hidden">
          <!-- Content Area -->
          <div class="flex-1 overflow-hidden flex flex-col">
            <!-- Header -->
            <div class="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 p-4 shadow-sm">
              <div class="flex flex-wrap justify-between items-center gap-4">
                <div class="flex items-center gap-3">
                  <h2 class="text-xl font-medium" :style="{ color: 'var(--clinic-font-color)' }">{{ currentView === 'list' ? 'Serviços Hospitalares' : 'Cadastro de Serviço' }}</h2>
                  <button v-if="currentView === 'form'"
                    class="w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
                    @click="goToList" aria-label="Voltar para lista">
                    <ArrowLeftIcon class="w-5 h-5" />
                  </button>
                </div>
                <div class="flex items-center gap-2">
                  <button v-if="currentView === 'list'"
                    class="clinic-btn text-white rounded-md transition-colors shadow-sm flex items-center gap-2"
                    @click="openNewServiceForm">
                    <PlusIcon class="w-4 h-4" />
                    <span>Novo Serviço</span>
                  </button>
                  <button v-if="currentView === 'form'"
                    class="clinic-btn text-white rounded-md transition-colors shadow-sm flex items-center gap-2"
                    @click="saveService" :disabled="!isFormValid">
                    <SaveIcon class="w-4 h-4" />
                    <span>{{ editMode ? 'Atualizar' : 'Salvar' }} Serviço</span>
                  </button>

                </div>
              </div>
            </div>

            <!-- Service List View -->
            <div v-if="currentView === 'list'" class="flex-1 overflow-y-auto p-4 bg-gray-50 dark:bg-gray-900">
              <div
                class="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-300 dark:border-gray-700 p-4">
                <!-- Search and Filter -->
                <div class="mb-4 flex flex-wrap gap-4 items-center">
                  <!-- Campo de busca -->
                  <div class="flex-1 min-w-[240px]">
                    <div class="relative">
                      <input type="text" v-model="searchQuery" placeholder="Buscar serviços..." @input="loadServices(1)"
                        class="h-10 w-full px-3 pl-10 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                      <SearchIcon class="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
                    </div>
                  </div>

                  <!-- Tipo de Exame -->
                  <div class="relative">
                    <select v-model="filterType" @change="loadServices(1)"
                      class="h-10 px-3 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:ring-2 focus:ring-blue-500 appearance-none pr-8">
                      <option value="">Todos os tipos</option>
                      <option value="Imagem">Imagem</option>
                      <option value="Consulta">Consulta</option>
                      <option value="Laboratório">Laboratório</option>
                      <option value="Procedimento">Procedimento</option>
                    </select>
                    <ChevronDownIcon
                      class="w-4 h-4 text-gray-500 absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none" />
                  </div>

                  <!-- Modalidade -->
                  <div class="relative">
                    <select v-model="filterModality" @change="loadServices(1)"
                      class="h-10 px-3 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:ring-2 focus:ring-blue-500 appearance-none pr-8">
                      <option value="">Todas as modalidades</option>
                      <option value="RX">RX</option>
                      <option value="US">US</option>
                      <option value="MG">MG</option>
                      <option value="TC">TC</option>
                      <option value="RM">RM</option>
                      <option value="PET">PET</option>
                      <option value="BMD">BMD</option>
                      <option value="PX">PX</option>
                      <option value="OUTRO">Outro</option>
                    </select>
                    <ChevronDownIcon
                      class="w-4 h-4 text-gray-500 absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none" />
                  </div>

                  <!-- Botão de reset -->
                  <button @click="resetFilters"
                    class="h-10 px-3 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm hover:bg-gray-50 dark:hover:bg-gray-800 focus:ring-2 focus:ring-blue-500">
                    <RefreshCwIcon class="w-4 h-4 inline-block" />
                  </button>
                </div>
<!-- Loading Overlay -->
<div v-if="isLoading" class="py-10 flex justify-center items-center">
  <LoaderIcon class="w-12 h-12 animate-spin text-gray-500 dark:text-gray-400" />
</div>

                <!-- Service Table -->
                
<!-- Service Table + Paginação -->
<div v-else class="overflow-x-auto">
                  <table class="w-full border-collapse">
                    <thead>
                      <tr class="bg-gray-50 dark:bg-gray-900/50 text-left">
                        <th
                          class="px-4 py-3 text-sm font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                          Código
                        </th>
                        <th
                          class="px-4 py-3 text-sm font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                          Descrição
                        </th>
                        <th
                          class="px-4 py-3 text-sm font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                          Tipo
                        </th>
                        <th
                          class="px-4 py-3 text-sm font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                          Modalidade
                        </th>
                        <th
                          class="px-4 py-3 text-sm font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                          Tempo (min)
                        </th>
                        <th
                          class="px-4 py-3 text-sm font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                          Status
                        </th>
                        <th
                          class="px-4 py-3 text-sm font-medium text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700">
                          Ações
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="filteredServices.length === 0">
                        <td colspan="7" class="px-4 py-6 text-center text-gray-500 dark:text-gray-400">
                          Nenhum serviço encontrado
                        </td>
                      </tr>
                      <tr v-for="service in filteredServices" :key="service.id"
                        class="border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors">
                        <td class="px-4 py-3 text-sm font-medium">{{ service.mnemonic }}</td>
                        <td class="px-4 py-3">
                          <div class="text-sm font-medium">{{ service.description }}</div>
                        </td>
                        <td class="px-4 py-3 text-sm">{{ service.examType }}</td>
                        <td class="px-4 py-3 text-sm">{{ service.modality }}</td>
                        <td class="px-4 py-3 text-sm">{{ service.examTime }}</td>
                        <td class="px-4 py-3 text-sm">
                          <span class="px-2 py-1 text-xs rounded-full" :class="{
                            'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-400': service.enabled,
                            'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-400': !service.enabled
                          }">
                            {{ service.enabled ? 'Ativo' : 'Inativo' }}
                          </span>
                        </td>
                        <td class="px-4 py-3 text-sm">
                          <div class="flex gap-2">
                            <button @click="editService(service)"
                              class="p-1 text-gray-500 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400"
                              title="Editar">
                              <EditIcon class="w-4 h-4" />
                            </button>
                            <button @click="confirmDeleteService(service)"
                              class="p-1 text-gray-500 hover:text-red-600 dark:text-gray-400 dark:hover:text-red-400"
                              title="Excluir">
                              <TrashIcon class="w-4 h-4" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- filepath: c:\Dev\Inova\inovamed\front-end\inovamed\src\views\settings\ServicesManagement.vue -->
                  <!-- PAGINAÇÃO NO NOVO ESTILO -->
                  <div class="flex flex-col md:flex-row md:items-center md:justify-between my-4 gap-2">
                    <div class="flex items-center gap-2 justify-center">
                      <button :disabled="currentPage === 1" @click="loadServices(currentPage - 1)"
                        class="px-3 py-1 rounded bg-emerald-500 dark:bg-gray-700 text-gray-200 dark:text-gray-200 disabled:opacity-50">Anterior</button>
                      <span class="text-sm text-gray-700 dark:text-gray-200">
                        Página {{ currentPage }} de {{ totalPages }}
                      </span>
                      <button :disabled="currentPage === totalPages || totalPages === 0"
                        @click="loadServices(currentPage + 1)"
                        class="px-3 py-1 rounded bg-emerald-500 dark:bg-gray-700 text-gray-200 dark:text-gray-200 disabled:opacity-50">Próxima</button>
                    </div>
                    <div class="flex items-center gap-2 justify-center">
                      <label for="page-size" class="text-sm text-gray-700 dark:text-gray-200">Itens por página:</label>
                      <select v-model.number="pageSize" @change="loadServices(1)"
                        class="rounded border px-2 py-1 text-sm dark:bg-gray-700 dark:text-white">
                        <option :value="5">5</option>
                        <option :value="10">10</option>
                        <option :value="20">20</option>
                        <option :value="50">50</option>
                      </select>
                      <span class="text-xs text-gray-500 dark:text-gray-400">Total: {{ totalCount }}</span>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <!-- Service Form View with Tabs -->
            <div v-if="currentView === 'form'" class="flex-1 overflow-y-auto p-4 bg-gray-50 dark:bg-gray-900">
              <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md border border-gray-300 dark:border-gray-700">
                <!-- Tabs Navigation -->
                <div class="border-b border-gray-200 dark:border-gray-700">
                  <div class="flex overflow-x-auto">
                    <button v-for="tab in tabs" :key="tab.id" @click="activeTab = tab.id"
                      class="px-4 py-3 text-sm font-medium whitespace-nowrap transition-colors focus:outline-none"
                      :class="{
                        'border-b-2': activeTab === tab.id,
                        'border-b-2': activeTab === tab.id
                      }"
                      :style="{
                        color: activeTab === tab.id ? 'var(--clinic-icon-color)' : 'var(--clinic-font-color)',
                        borderColor: activeTab === tab.id ? 'var(--clinic-icon-color)' : 'transparent'
                      }">
                      <div class="flex items-center gap-2">
                        <component :is="tab.icon" class="w-4 h-4" />
                        {{ tab.name }}
                      </div>
                    </button>
                  </div>
                </div>

                <!-- Tab Content -->
                <div class="p-6">
                  <!-- Página 1 - Identificação e Configurações Básicas -->
                  <div v-if="activeTab === 'identification'" class="space-y-6">
                    <!-- Identificação do Serviço -->
                    <div>
                      <h3 class="text-lg font-medium mb-4 text-gray-900 dark:text-white">Identificação do Serviço</h3>
                      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="md:col-span-2">
                          <label for="description" class="block text-sm font-medium mb-1">Descrição do Serviço*</label>
                          <input id="description" type="text" v-model="currentService.description" required
                            class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                        </div>

                        <div>
                          <label for="mnemonic" class="block text-sm font-medium mb-1">Mnemônico*</label>
                          <input id="mnemonic" type="text" v-model="currentService.mnemonic" required
                            class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                        </div>

                        <div>
                          <label for="examType" class="block text-sm font-medium mb-1">Tipo de Exame*</label>
                          <select id="examType" v-model="currentService.examType" required
                            class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none pr-8">
                            <option value="">Selecione</option>
                            <option value="Imagem">Imagem</option>
                            <option value="Consulta">Consulta</option>
                            <option value="Laboratório">Laboratório</option>
                            <option value="Procedimento">Procedimento</option>
                          </select>
                        </div>
                      </div>

                      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                        <div class="flex items-center">
                          <input id="allowsMaterialCollection" type="checkbox"
                            v-model="currentService.allowsMaterialCollection"
                            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                          <label for="allowsMaterialCollection"
                            class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                            Admite coleta de material
                          </label>
                        </div>

                        <div class="flex items-center">
                          <input id="allowsComplementaryExam" type="checkbox"
                            v-model="currentService.allowsComplementaryExam"
                            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                          <label for="allowsComplementaryExam"
                            class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                            Permite exame complementar
                          </label>
                        </div>
                      </div>
                    </div>

                    <!-- Preparo -->
                    <div>
                      <h3 class="text-lg font-medium mb-4 text-gray-900 dark:text-white">Preparo</h3>
                      <div>
                        <label for="preparation" class="block text-sm font-medium mb-1">Campo Preparo</label>
                        <textarea id="preparation" v-model="currentService.preparation" rows="3"
                          class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"></textarea>
                      </div>
                    </div>

                    <!-- Tipo de Laudo -->
                    <div>
                      <h3 class="text-lg font-medium mb-4 text-gray-900 dark:text-white">Tipo de Laudo</h3>
                      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label for="reportType" class="block text-sm font-medium mb-1">Laudo*</label>
                          <select id="reportType" v-model="currentService.reportType" required
                            class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none pr-8">
                            <option value="">Selecione</option>
                            <option value="normal">Normal</option>
                            <option value="eco">Eco</option>
                            <option value="miocardio">Miocárdio</option>
                            <option value="mapa_adulto">Mapa Adulto</option>
                            <option value="mapa_crianca">Mapa Criança</option>
                          </select>
                        </div>


                        <div>
                          <label for="modality" class="block text-sm font-medium mb-1">Modalidade*</label>
                          <select id="modality" v-model="currentService.modality" required
                            class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none pr-8">
                            <option value="">Selecione</option>
                            <option value="RX">RX</option>
                            <option value="US">US</option>
                            <option value="MG">MG</option>
                            <option value="TC">TC</option>
                            <option value="RM">RM</option>
                            <option value="PET">PET</option>
                            <option value="PX">PX</option>
                            <option value="BMD">BMD</option>
                            <option value="OUTRO">Outro</option>
                          </select>
                        </div>

                        <div>
                          <label for="reportRevision" class="block text-sm font-medium mb-1">Laudo possui
                            revisão*</label>
                          <select id="reportRevision" v-model="currentService.reportRevision" required
                            class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none pr-8">
                            <option value="">Selecione</option>
                            <option value="sim">Sim</option>
                            <option value="nao">Não</option>
                            <option value="opcional">Opcional</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Página 1 Continuação - Restrições e Configurações -->
                  <div v-if="activeTab === 'restrictions'" class="space-y-6">
                    <!-- Restrições -->
                    <div>
                      <h3 class="text-lg font-medium mb-4 text-gray-900 dark:text-white">Restrições</h3>
                      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div>
                          <label for="gender" class="block text-sm font-medium mb-1">Sexo*</label>
                          <select id="gender" v-model="currentService.gender" required
                            class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none pr-8">
                            <option value="ambos">Ambos</option>
                            <option value="masculino">Masculino</option>
                            <option value="feminino">Feminino</option>
                          </select>
                        </div>

                        <div>
                          <label for="minAge" class="block text-sm font-medium mb-1">Idade mínima</label>
                          <input id="minAge" type="number" min="0" v-model="currentService.minAge"
                            class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                        </div>

                        <div>
                          <label for="maxAge" class="block text-sm font-medium mb-1">Idade máxima</label>
                          <input id="maxAge" type="number" min="0" v-model="currentService.maxAge"
                            class="w-full px-3 py-2	border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                        </div>
                      </div>
                    </div>

                    <!-- Consentimento -->
                    <div>
                      <h3 class="text-lg font-medium mb-4 text-gray-900 dark:text-white">Consentimento</h3>
                      <div>
                        <label for="consent" class="block text-sm font-medium mb-1">Campo de texto para
                          Consentimento</label>
                        <textarea id="consent" v-model="currentService.consent" rows="4"
                          class="w-full px-3 py-2	border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"></textarea>
                      </div>
                    </div>

                    <!-- Worklist e Exibição -->
                    <div>
                      <h3 class="text-lg font-medium mb-4 text-gray-900 dark:text-white">Worklist e Exibição</h3>
                      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="space-y-3">
                          <div class="flex items-center">
                            <input id="generateWorklist" type="checkbox" v-model="currentService.generateWorklist"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="generateWorklist" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Gerar Worklist*
                            </label>
                          </div>

                          <div class="flex items-center">
                            <input id="showOnWeb" type="checkbox" v-model="currentService.showOnWeb"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="showOnWeb" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Exibir Web (portal)
                            </label>
                          </div>

                          <div class="flex items-center">
                            <input id="serviceForm" type="checkbox" v-model="currentService.serviceForm"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="serviceForm" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Ficha do Serviço
                            </label>
                          </div>
                        </div>

                        <div class="space-y-3">
                          <div class="flex items-center">
                            <input id="schedulingForm" type="checkbox" v-model="currentService.schedulingForm"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="schedulingForm" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Ficha de Marcação
                            </label>
                          </div>

                          <div class="flex items-center">
                            <input id="deliveryProtocol" type="checkbox" v-model="currentService.deliveryProtocol"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="deliveryProtocol" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Protocolo de Entrega
                            </label>
                          </div>

                          <div class="flex items-center">
                            <input id="enabled" type="checkbox" v-model="currentService.enabled"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="enabled" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Habilitado*
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Página 2 - Técnica e Tempo -->
                  <div v-if="activeTab === 'technique'" class="space-y-6">
                    <!-- Técnica e Tempo -->
                    <div>
                      <h3 class="text-lg font-medium mb-4 text-gray-900 dark:text-white">Técnica e Tempo</h3>
                      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label for="technique" class="block text-sm font-medium mb-1">Técnica*</label>
                          <select id="technique" v-model="currentService.technique" required
                            class="w-full px-3 py-2 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none pr-8">
                            <option value="">Selecione</option>
                            <option value="convencional">Convencional</option>
                            <option value="videolaparoscopia">Videolaparoscopia</option>
                            <option value="robotica">Robótica</option>
                            <option value="nao_definida">Não definida</option>
                          </select>
                        </div>

                        <div>
                          <label for="contrastTime" class="block text-sm font-medium mb-1">Tempo para aplicação do
                            contraste (min)</label>
                          <input id="contrastTime" type="number" min="0" v-model="currentService.contrastTime"
                            class="w-full px-3 py-2	border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                        </div>

                        <div>
                          <label for="arrivalTime" class="block text-sm font-medium mb-1">Tempo antes do exame para
                            chegada (min)</label>
                          <input id="arrivalTime" type="number" min="0" v-model="currentService.arrivalTime"
                            class="w-full px-3 py-2	border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                        </div>

                        <div>
                          <label for="examTime" class="block text-sm font-medium mb-1">Tempo do exame (min)*</label>
                          <input id="examTime" type="number" min="1" v-model="currentService.examTime" required
                            class="w-full px-3 py-2	border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                        </div>

                        <div>
                          <label for="deliveryTime" class="block text-sm font-medium mb-1">Tempo de entrega
                            (dias)*</label>
                          <input id="deliveryTime" type="number" min="1" v-model="currentService.deliveryTime" required
                            class="w-full px-3 py-2	border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                        </div>
                      </div>
                    </div>

                    <!-- Controle de horário -->
                    <div>
                      <h3 class="text-lg font-medium mb-4 text-gray-900 dark:text-white">Controle de Horário</h3>
                      <div class="space-y-4">
                        <div class="flex items-center">
                          <input id="enableTimeControl" type="checkbox" v-model="currentService.enableTimeControl"
                            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                          <label for="enableTimeControl" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                            Habilitar controle de horário
                          </label>
                        </div>

                        <div v-if="currentService.enableTimeControl" class="grid grid-cols-1 md:grid-cols-2 gap-4">
                          <div>
                            <label for="executionSchedule" class="block text-sm font-medium mb-1">Horário de
                              Execução*</label>
                            <input id="executionSchedule" type="time" v-model="currentService.executionSchedule"
                              required
                              class="w-full px-3 py-2	border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                          </div>

                          <div>
                            <label for="maxExams" class="block text-sm font-medium mb-1">Quantidade máxima de
                              exames</label>
                            <input id="maxExams" type="number" min="1" v-model="currentService.maxExams"
                              class="w-full px-3 py-2	border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Página 2 Continuação - Comportamentos -->
                  <div v-if="activeTab === 'behaviors'" class="space-y-6">
                    <!-- Comportamentos do exame -->
                    <div>
                      <h3 class="text-lg font-medium mb-4 text-gray-900 dark:text-white">Comportamentos do Exame</h3>
                      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div class="space-y-3">
                          <div class="flex items-center">
                            <input id="mandatoryContrastFilling" type="checkbox"
                              v-model="currentService.mandatoryContrastFilling"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="mandatoryContrastFilling"
                              class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Preenchimento de contraste no laudo obrigatório
                            </label>
                          </div>

                          <div class="flex items-center">
                            <input id="appearsInQueue" type="checkbox" v-model="currentService.appearsInQueue"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="appearsInQueue" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Aparece na fila de atendimento*
                            </label>
                          </div>

                          <div class="flex items-center">
                            <input id="mandatoryFilmFilling" type="checkbox"
                              v-model="currentService.mandatoryFilmFilling"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="mandatoryFilmFilling"
                              class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Preenchimento de películas obrigatório
                            </label>
                          </div>

                          <div class="flex items-center">
                            <input id="allowWebScheduling" type="checkbox" v-model="currentService.allowWebScheduling"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="allowWebScheduling" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Permitir agendamento web
                            </label>
                          </div>

                          <div class="flex items-center">
                            <input id="isTeleconsultation" type="checkbox" v-model="currentService.isTeleconsultation"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="isTeleconsultation" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Serviço é uma teleconsulta
                            </label>
                          </div>

                          <div class="flex items-center">
                            <input id="cannotBeConfirmed" type="checkbox" v-model="currentService.cannotBeConfirmed"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="cannotBeConfirmed" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Serviço não pode ser confirmado
                            </label>
                          </div>

                          <div class="flex items-center">
                            <input id="allowLaudoWithoutPrintSeries" type="checkbox" v-model="currentService.allowLaudoWithoutPrintSeries"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="allowLaudoWithoutPrintSeries" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Permitir laudar se não houver série de impressão
                            </label>
                          </div>
                        </div>

                        <div class="space-y-3">
                          <div class="flex items-center">
                            <input id="acceptsAnesthesia" type="checkbox" v-model="currentService.acceptsAnesthesia"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="acceptsAnesthesia" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Aceita anestesia
                            </label>
                          </div>

                          <div class="flex items-center">
                            <input id="acceptsTriage" type="checkbox" v-model="currentService.acceptsTriage"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="acceptsTriage" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Aceita triagem
                            </label>
                          </div>

                          <div class="flex items-center">
                            <input id="acceptsNursingEvolution" type="checkbox"
                              v-model="currentService.acceptsNursingEvolution"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="acceptsNursingEvolution"
                              class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Aceita evolução de enfermagem
                            </label>
                          </div>

                          <div class="flex items-center">
                            <input id="acceptsExamRequest" type="checkbox" v-model="currentService.acceptsExamRequest"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="acceptsExamRequest" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Aceita solicitação de exames*
                            </label>
                          </div>

                          <div class="flex items-center">
                            <input id="acceptsMedicalPrescription" type="checkbox"
                              v-model="currentService.acceptsMedicalPrescription"
                              class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" />
                            <label for="acceptsMedicalPrescription"
                              class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                              Aceita prescrição médica
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Aba de Convênios -->
                  <div v-if="activeTab === 'insurances'" class="space-y-6">
                    <h3 class="text-lg font-medium text-gray-900 dark:text-white">Vincular Convênios ao Serviço</h3>
                    <p class="text-sm text-gray-600 dark:text-gray-400">Associe os convênios que cobrem este serviço. A lista de convênios é gerenciada na tela de "Convênios Hospitalares".</p>

                    <div class="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-4 items-start">
                    
                    <div class="flex flex-col gap-2">
                        <label for="insurance-search" class="text-sm font-medium text-gray-700 dark:text-gray-300">Convênios Disponíveis</label>
                        <div class="relative">
                        <input
                            id="insurance-search"
                            type="text"
                            v-model="insuranceSearchQuery"
                            placeholder="Buscar convênio..."
                            class="h-10 w-full px-3 pl-10 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        <SearchIcon class="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
                        </div>
                        <div class="border rounded-md bg-white dark:bg-gray-900 dark:border-gray-700 h-72 overflow-y-auto">
                        <ul v-if="availableInsurances.length > 0">
                            <li
                            v-for="insurance in availableInsurances"
                            :key="insurance.id"
                            @click="toggleInsuranceSelection('available', insurance.id)"
                            class="px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700"
                            :class="{ 'bg-blue-100 dark:bg-blue-900/50': selectedAvailableInsurances.includes(insurance.id) }"
                            >
                            {{ insurance.nome || insurance.name || 'Convênio sem nome' }}
                            </li>
                        </ul>
                        <div v-else class="text-center text-sm text-gray-500 p-4">
                            Nenhum convênio disponível ou todos já foram vinculados.
                        </div>
                        </div>
                    </div>

                    <div class="flex flex-col gap-2 self-center pt-16">
                        <button @click="moveSelectedInsurancesToRight" :disabled="selectedAvailableInsurances.length === 0" class="p-2 border rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed" aria-label="Mover selecionado para a direita">
                            &gt;
                        </button>
                        <button @click="moveAllInsurancesToRight" :disabled="availableInsurances.length === 0" class="p-2 border rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed" aria-label="Mover todos para a direita">
                            &gt;&gt;
                        </button>
                        <button @click="moveSelectedInsurancesToLeft" :disabled="selectedLinkedInsurances.length === 0" class="p-2 border rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed" aria-label="Mover selecionado para a esquerda">
                            &lt;
                        </button>
                        <button @click="moveAllInsurancesToLeft" :disabled="linkedInsurances.length === 0" class="p-2 border rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed" aria-label="Mover todos para a esquerda">
                            &lt;&lt;
                        </button>
                    </div>

                    <div class="flex flex-col gap-2">
                        <label class="text-sm font-medium text-gray-700 dark:text-gray-300">Convênios Vinculados</label>
                        <div class="border rounded-md bg-white dark:bg-gray-900 dark:border-gray-700 h-72 mt-[2.5rem] overflow-y-auto">
                            <ul v-if="linkedInsurances.length > 0">
                            <li
                                v-for="insurance in linkedInsurances"
                                :key="insurance.id"
                                class="px-3 py-2 text-sm border-b border-gray-100 dark:border-gray-700 last:border-b-0 cursor-pointer hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
                                @click="unlinkInsurance(insurance.id)"
                                title="Clique para desvincular este convênio"
                            >
                                <div class="flex items-center justify-between">
                                    <span>{{ insurance.nome || insurance.name || 'Convênio sem nome' }} <span class="text-gray-600 font-medium">R$ {{ getServiceValue(insurance.id, 'value')?.toFixed(2) || '0.00' }}</span></span>
                                    <div class="flex items-center space-x-2">


                                        <button
                                            @click.stop="openEditInsuranceValueModal(insurance)"
                                            class="p-1 text-gray-500 hover:text-blue-600 dark:text-gray-400 dark:hover:text-blue-400"
                                            title="Editar valores"
                                        >
                                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </li>
                            </ul>
                            <div v-else class="text-center text-sm text-gray-500 p-4">
                                Nenhum convênio vinculado a este serviço.
                            </div>
                        </div>
                        
                    </div>

                    </div>
                  </div>

                  <!-- Nova Aba de Anamneses -->
                  <div v-if="activeTab === 'anamneses'" class="space-y-6">
                    <h3 class="text-lg font-medium text-gray-900 dark:text-white">Gerenciar Anamneses do Serviço</h3>
                    <p class="text-sm text-gray-600 dark:text-gray-400">
                      Associe questionários de anamnese que devem ser preenchidos para este serviço. 
                      As anamneses são gerenciadas na tela de "Gerenciar Anamneses".
                    </p>

                    <div class="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-4 items-start">
                      <!-- Anamneses Disponíveis -->
                      <div class="flex flex-col gap-2">
                        <label for="anamnesis-search" class="text-sm font-medium text-gray-700 dark:text-gray-300">
                          Anamneses Disponíveis
                        </label>
                        <div class="relative">
                          <input
                            id="anamnesis-search"
                            type="text"
                            v-model="anamnesisSearchQuery"
                            placeholder="Buscar anamnese..."
                            class="h-10 w-full px-3 pl-10 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-900 text-gray-800 dark:text-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                          />
                          <SearchIcon class="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
                        </div>
                        <div class="border rounded-md bg-white dark:bg-gray-900 dark:border-gray-700 h-72 overflow-y-auto">
                          <ul v-if="availableAnamneses.length > 0">
                            <li
                              v-for="anamnesis in availableAnamneses"
                              :key="anamnesis.id"
                              @click="toggleAnamnesisSelection('available', anamnesis.id)"
                              class="px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 border-b border-gray-100 dark:border-gray-700 last:border-b-0"
                              :class="{ 'bg-blue-100 dark:bg-blue-900/50': selectedAvailableAnamneses.includes(anamnesis.id) }"
                            >
                              <div class="font-medium">{{ anamnesis.title }}</div>
                              <div class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                {{ anamnesis.titulo || 'Sem descrição' }}
                              </div>
                              <div class="text-xs text-gray-400 dark:text-gray-500 mt-1">
                                {{ anamnesis.questions_count || 0 }} pergunta(s)
                              </div>
                            </li>
                          </ul>
                          <div v-else class="text-center text-sm text-gray-500 p-4">
                            Nenhuma anamnese disponível ou todas já foram vinculadas.
                          </div>
                        </div>
                      </div>

                      <!-- Botões de Controle -->
                      <div class="flex flex-col gap-2 self-center pt-16">
                        <button 
                          @click="moveSelectedAnamnesestoRight" 
                          :disabled="selectedAvailableAnamneses.length === 0" 
                          class="p-2 border rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed" 
                          aria-label="Mover selecionado para a direita"
                          title="Vincular anamneses selecionadas"
                        >
                          &gt;
                        </button>
                        <button 
                          @click="moveAllAnamnesestoRight" 
                          :disabled="availableAnamneses.length === 0" 
                          class="p-2 border rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed" 
                          aria-label="Mover todos para a direita"
                          title="Vincular todas as anamneses"
                        >
                          &gt;&gt;
                        </button>
                        <button 
                          @click="moveSelectedAnamnesestoLeft" 
                          :disabled="selectedLinkedAnamneses.length === 0" 
                          class="p-2 border rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed" 
                          aria-label="Mover selecionado para a esquerda"
                          title="Desvincular anamneses selecionadas"
                        >
                          &lt;
                        </button>
                        <button 
                          @click="moveAllAnamnesestoLeft" 
                          :disabled="linkedAnamneses.length === 0" 
                          class="p-2 border rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed" 
                          aria-label="Mover todos para a esquerda"
                          title="Desvincular todas as anamneses"
                        >
                          &lt;&lt;
                        </button>
                      </div>

                      <!-- Anamneses Vinculadas -->
                      <div class="flex flex-col gap-2">
                        <label class="text-sm font-medium text-gray-700 dark:text-gray-300">
                          Anamneses Vinculadas ao Serviço
                        </label>
                        <div class="border rounded-md bg-white dark:bg-gray-900 dark:border-gray-700 h-72 mt-[2.5rem] overflow-y-auto">
                          <ul v-if="linkedAnamneses.length > 0">
                            <li
                              v-for="anamnesis in linkedAnamneses"
                              :key="anamnesis.id"
                              @click="toggleAnamnesisSelection('linked', anamnesis.id)"
                              class="px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 border-b border-gray-100 dark:border-gray-700 last:border-b-0"
                              :class="{ 'bg-blue-100 dark:bg-blue-900/50': selectedLinkedAnamneses.includes(anamnesis.id) }"
                            >
                              <div class="font-medium">{{ anamnesis.title }}</div>
                              <div class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                                {{ anamnesis.titulo || 'Sem descrição' }}
                              </div>
                              <div class="text-xs text-gray-400 dark:text-gray-500 mt-1">
                                {{ anamnesis.questions_count || 0 }} pergunta(s)
                              </div>
                            </li>
                          </ul>
                          <div v-else class="text-center text-sm text-gray-500 p-4">
                            Nenhuma anamnese vinculada a este serviço.
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Configurações Adicionais -->
                    <div class="mt-6 p-4 bg-gray-50 dark:bg-gray-800/50 rounded-lg">
                      <h4 class="text-sm font-medium text-gray-900 dark:text-white mb-3">Configurações das Anamneses</h4>
                      <div class="space-y-3">
                        <div class="flex items-center">
                          <input 
                            id="mandatoryAnamnesis" 
                            type="checkbox" 
                            v-model="currentService.mandatoryAnamnesis"
                            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" 
                          />
                          <label for="mandatoryAnamnesis" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                            Preenchimento de anamnese obrigatório
                          </label>
                        </div>
                        <div class="flex items-center">
                          <input 
                            id="anamnesisBeforeExam" 
                            type="checkbox" 
                            v-model="currentService.anamnesisBeforeExam"
                            class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" 
                          />
                          <label for="anamnesisBeforeExam" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                            Anamnese deve ser preenchida antes do exame
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Aba SIGTAP -->
                  <div v-if="activeTab === 'sigtap'" class="space-y-6">
                    <h3 class="text-lg font-medium text-gray-900 dark:text-white">Faturamento - Códigos por Convênio</h3>
                    <p class="text-sm text-gray-600 dark:text-gray-400">Defina o código do convênio e o código de classificação para cada convênio vinculado a este serviço. Ambos são opcionais.</p>

                    <!-- Instrumento de Registro -->
                    <fieldset class="border rounded-lg p-4 bg-gray-50 dark:bg-gray-800">
                      <legend class="px-2 text-sm font-medium text-gray-700 dark:text-gray-300">Instrumento de Registro</legend>
                      <div class="mt-3 flex flex-wrap gap-6 text-sm text-gray-900 dark:text-white">
                        <label class="inline-flex items-center gap-2">
                          <input
                            type="checkbox"
                            class="rounded border-gray-300 dark:border-gray-600"
                            value="BPA-C"
                            v-model="currentService.registrationInstruments"
                          />
                          <span>BPA-C</span>
                        </label>
                        <label class="inline-flex items-center gap-2">
                          <input
                            type="checkbox"
                            class="rounded border-gray-300 dark:border-gray-600"
                            value="BPA-I"
                            v-model="currentService.registrationInstruments"
                          />
                          <span>BPA-I</span>
                        </label>
                        <label class="inline-flex items-center gap-2">
                          <input
                            type="checkbox"
                            class="rounded border-gray-300 dark:border-gray-600"
                            value="AIH"
                            v-model="currentService.registrationInstruments"
                          />
                          <span>AIH</span>
                        </label>
                        <label class="inline-flex items-center gap-2">
                          <input
                            type="checkbox"
                            class="rounded border-gray-300 dark:border-gray-600"
                            value="APAC"
                            v-model="currentService.registrationInstruments"
                          />
                          <span>APAC</span>
                        </label>
                      </div>
                    </fieldset>

                    <div v-if="linkedInsurances.length > 0" class="space-y-4">
                      <div v-for="insurance in linkedInsurances" :key="insurance.id" class="border rounded-lg p-4 bg-gray-50 dark:bg-gray-800 flex flex-col md:flex-row md:items-center md:gap-6">
                        <div class="font-medium text-gray-900 dark:text-white md:w-1/4">{{ insurance.nome || insurance.name || 'Convênio sem nome' }}</div>
                        <div class="flex flex-col md:flex-row md:gap-4 flex-1 mt-2 md:mt-0">
                          <div>
                            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Cód. Convênio</label>
                            <input type="text" class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500" :value="getSigtapCode(insurance.id, 'codigo_convenio')" @input="e => setSigtapCode(insurance.id, 'codigo_convenio', e.target.value)" placeholder="Opcional" />
                          </div>
                          <div>
                            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Cód. Serviço</label>
                            <input type="text" class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500" :value="getSigtapCode(insurance.id, 'cod_serv_sus')" @input="e => setSigtapCode(insurance.id, 'cod_serv_sus', e.target.value)" placeholder="Opcional" />
                          </div>
                          <div>
                            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Cód. Classificação</label>
                            <input type="text" class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500" :value="getSigtapCode(insurance.id, 'codigo_classificacao')" @input="e => setSigtapCode(insurance.id, 'codigo_classificacao', e.target.value)" placeholder="Opcional" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="text-center text-sm text-gray-500 p-4">Nenhum convênio vinculado a este serviço.</div>
                  </div>

                  <!-- Form Actions -->
                  <div class="mt-8 flex justify-between items-center">
                    <div class="flex gap-2">
                      <!-- Navigation buttons could go here -->
                    </div>
                    <div class="flex gap-3">
                      <button
                        class="px-4 py-2 border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-md transition-colors"
                        @click="goToList">
                        Cancelar
                      </button>
                      <button
                        class="clinic-btn text-white rounded-md transition-colors shadow-sm disabled:bg-gray-300 dark:disabled:bg-gray-600 disabled:cursor-not-allowed flex items-center gap-2"
                        @click="saveService" :disabled="!isFormValid">
                        <SaveIcon class="w-4 h-4" />
                        {{ editMode ? 'Salvar' : 'Salvar' }} 
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Success Modal -->
            <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
              v-if="showSuccessModal" @click.self="closeSuccessModal">
              <div
                class="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto animate-fadeIn">
                <div class="p-6 text-center">
                  <div
                    class="w-16 h-16 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center text-green-600 dark:text-green-400 mx-auto mb-4">
                    <CheckIcon class="w-8 h-8" />
                  </div>
                  <h3 class="text-xl font-medium mb-2">{{ editMode ? 'Serviço Atualizado' : 'Serviço Cadastrado' }}</h3>
                  <p class="text-gray-600 dark:text-gray-400 mb-6">
                    {{ editMode ? 'O serviço foi atualizado com sucesso.' : 'O serviço foi cadastrado com sucesso no sistema.' }}
                  </p>
                  <div class="flex justify-center gap-3">
                    <button
                      class="clinic-btn text-white rounded-md transition-colors shadow-sm"
                      @click="closeSuccessModal">
                      OK
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Delete Confirmation Modal -->
            <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
              v-if="showDeleteModal" @click.self="showDeleteModal = false">
              <div
                class="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto animate-fadeIn">
                <div class="p-6">
                  <div
                    class="w-16 h-16 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center text-red-600 dark:text-red-400 mx-auto mb-4">
                    <AlertTriangleIcon class="w-8 h-8" />
                  </div>
                  <h3 class="text-xl font-medium mb-2 text-center">Confirmar Exclusão</h3>
                  <p class="text-gray-600 dark:text-gray-400 mb-6 text-center">
                    Tem certeza que deseja excluir o serviço <span class="font-medium">{{ serviceToDelete?.description
                      }}</span>?
                    <br />Esta ação não pode ser desfeita.
                  </p>
                  <div class="flex justify-end gap-3">
                    <button
                      class="px-4 py-2 border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-md transition-colors"
                      @click="showDeleteModal = false">
                      Cancelar
                    </button>
                    <button
                      class="px-4 py-2 bg-red-500 hover:bg-red-600 text-white rounded-md transition-colors shadow-sm"
                      @click="deleteService">
                      Excluir
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
    <!-- Modal de Edição de Valores do Convênio -->
    <div v-if="showEditInsuranceModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" @click.self="closeEditInsuranceModal">
        <div class="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-md mx-4">
            <h3 class="text-lg font-medium text-gray-900 dark:text-white mb-4">
                Editar Valores - {{ editingInsurance?.nome || editingInsurance?.name || 'Convênio' }}
            </h3>
            
            <form @submit.prevent="saveInsuranceValueEdit" class="space-y-4">
                <div>
                    <label for="edit-value" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Valor (R$)
                    </label>
                    <input
                        id="edit-value"
                        type="number"
                        step="0.01"
                        min="0"
                        v-model="editForm.value"
                        class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        required
                    />
                </div>
                
                <div class="flex items-center">
                    <input
                        id="edit-enabled"
                        type="checkbox"
                        v-model="editForm.enabled"
                        class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <label for="edit-enabled" class="ml-2 block text-sm text-gray-900 dark:text-gray-300">
                        Ativo
                    </label>
                </div>
                
                <div class="flex justify-end space-x-3 pt-4">
                    <button
                        type="button"
                        @click="closeEditInsuranceModal"
                        class="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700"
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        class="px-4 py-2 bg-blue-600 text-white rounded-md text-sm font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        Salvar
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>
  </BaseTemplate>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import BaseTemplate from '../templates/BaseTemplate.vue';
import apiClient from '@/services/authService';
import { useClinicStore } from '@/stores/settings/clinicStore';

import {
  Plus as PlusIcon,
  ChevronDown as ChevronDownIcon,
  Check as CheckIcon,
  Edit as EditIcon,
  Trash as TrashIcon,
  Save as SaveIcon,
  ArrowLeft as ArrowLeftIcon,
  RefreshCw as RefreshCwIcon,
  SearchIcon, // Corrigido para corresponder ao seu uso original
  LoaderIcon,
  AlertTriangle as AlertTriangleIcon,
  FileText as FileTextIcon,
  Settings as SettingsIcon,
  Clock as ClockIcon,
  Activity as ActivityIcon,
  Shield as ShieldIcon, // Ícone para a aba de convênios
  ClipboardList as ClipboardListIcon, // Ícone para a nova aba de anamneses
  Clipboard as ClipboardIcon,
} from 'lucide-vue-next';

// Inicializa o clinicStore (usado para aplicar estilos CSS automaticamente)
useClinicStore();

// Estado de exibição
const currentView = ref('list');
const editMode = ref(false);
const showSuccessModal = ref(false);
const showDeleteModal = ref(false);
const serviceToDelete = ref(null);
const searchQuery = ref('');
const filterType = ref('');
const activeTab = ref('identification');
const filterModality = ref('');
const currentPage = ref(1);
const pageSize = ref(10);
const totalCount = ref(0);
const isLoading = ref(false);

// Abas - Adicionada nova aba de anamneses
const tabs = [
  { id: 'identification', name: 'Identificação', icon: FileTextIcon },
  { id: 'restrictions', name: 'Restrições', icon: SettingsIcon },
  { id: 'technique', name: 'Técnica', icon: ClockIcon },
  { id: 'behaviors', name: 'Comportamentos', icon: ActivityIcon },
  { id: 'insurances', name: 'Convênios', icon: ShieldIcon },
  { id: 'sigtap', name: 'Faturamento', icon: ClipboardIcon },
  { id: 'anamneses', name: 'Anamneses', icon: ClipboardListIcon }
];

// Modelo vazio - Adicionados campos para anamneses
const emptyService = {
  id: null,
  description: '',
  mnemonic: '',
  examType: '',
  allowsMaterialCollection: false,
  allowsComplementaryExam: false,
  preparation: '',
  reportType: '',
  modality: '',
  reportRevision: '',
  gender: 'ambos',
  minAge: null,
  maxAge: null,
  consent: '',
  generateWorklist: true,
  showOnWeb: false,
  serviceForm: false,
  schedulingForm: false,
  deliveryProtocol: false,
  enabled: true,
  technique: '',
  contrastTime: null,
  arrivalTime: null,
  examTime: null,
  deliveryTime: null,
  enableTimeControl: false,
  executionSchedule: '',
  maxExams: null,
  mandatoryContrastFilling: false,
  appearsInQueue: true,
  mandatoryFilmFilling: false,
  allowWebScheduling: false,
  isTeleconsultation: false,
  cannotBeConfirmed: false,
  acceptsAnesthesia: false,
  acceptsTriage: false,
  acceptsNursingEvolution: false,
  acceptsExamRequest: true,
  acceptsMedicalPrescription: false,
  insurance_ids: [], // Campo para vincular convênios
  anamnesis_ids: [], // Campo para vincular anamneses
  mandatoryAnamnesis: false, // Anamnese obrigatória
  anamnesisBeforeExam: false, // Anamnese antes do exame
  allowLaudoWithoutPrintSeries: true, // Permitir laudo sem série de impressão
  sigtap_codes: {}, // { [insurance_id]: { codigo_convenio: '', codigo_classificacao: '', cod_serv_sus } }
  registrationInstruments: [], // Instrumentos de Registro (BPA-C, BPA-I, AIH, APAC)
  service_values: {}, // { [insurance_id]: { value: 0.00, enabled: true } }
};

// --- LÓGICA PARA A ABA DE CONVÊNIOS ---
const allInsurances = ref([]);
const insuranceSearchQuery = ref('');
const selectedAvailableInsurances = ref([]);
const selectedLinkedInsurances = ref([]);

const availableInsurances = computed(() => {
    if (!currentService.value) return [];
    const linkedIds = new Set(currentService.value.insurance_ids);
    const query = insuranceSearchQuery.value.toLowerCase();
    return allInsurances.value.filter(ins => {
        const isNotLinked = !linkedIds.has(ins.id);
        const matchesSearch = (ins.nome || '').toLowerCase().includes(query);
        return isNotLinked && matchesSearch;
    });
});

const linkedInsurances = computed(() => {
    if (!currentService.value) return [];
    const linkedIds = new Set(currentService.value.insurance_ids);
    return allInsurances.value.filter(ins => linkedIds.has(ins.id));
});

async function loadAllInsurances() {
    try {
        const { data } = await apiClient.get('/api/v1/faturamento/insurances?ativo=true');
        allInsurances.value = data || [];
    } catch (err) {
        console.error('Erro ao carregar convênios:', err);
    }
}

// --- LÓGICA PARA A ABA DE ANAMNESES ---
const allAnamneses = ref([]);
const anamnesisSearchQuery = ref('');
const selectedAvailableAnamneses = ref([]);
const selectedLinkedAnamneses = ref([]);

const availableAnamneses = computed(() => {
    if (!currentService.value) return [];
    const linkedIds = new Set(currentService.value.anamnesis_ids);
    const query = anamnesisSearchQuery.value.toLowerCase();
    return allAnamneses.value.filter(anamnesis => {
        const isNotLinked = !linkedIds.has(anamnesis.id);
        const matchesSearch = (anamnesis.title || '').toLowerCase().includes(query) ||
                             (anamnesis.description || '').toLowerCase().includes(query);
        return isNotLinked && matchesSearch;
    });
});

const linkedAnamneses = computed(() => {
    if (!currentService.value) return [];
    const linkedIds = new Set(currentService.value.anamnesis_ids);
    return allAnamneses.value.filter(anamnesis => linkedIds.has(anamnesis.id));
});

async function loadAllAnamneses() {
    try {
        const { data } = await apiClient.get('/api/v1/anamneses/list/?page_size=100');
        allAnamneses.value = data.results || [];
    } catch (err) {
        console.error('Erro ao carregar anamneses:', err);
    }
}

// Dados reativos
const services = ref([]);
const currentService = ref({ ...emptyService });

// Mapeia resposta da API (snake_case) → UI (camelCase)
function transformApiToUi(api) {
  // Processar service_values para garantir formato correto
  const processedServiceValues = {};
  if (api.service_values && Object.keys(api.service_values).length > 0) {
    Object.keys(api.service_values).forEach(insuranceId => {
      processedServiceValues[insuranceId] = {
        value: parseFloat(api.service_values[insuranceId].valor) || 0.00,
        enabled: Boolean(api.service_values[insuranceId].ativo)
      };
    });
  }

  return {
    id: api.id,
    description: api.descricao,
    mnemonic: api.mnemonico,
    examType: api.tipo_exame,
    allowsMaterialCollection: api.admite_coleta_material,
    allowsComplementaryExam: api.permite_exame_complementar,
    preparation: api.preparo,
    reportType: api.laudo,
    modality: api.modalidade,
    reportRevision: api.laudo_possui_revisao,
    gender: api.sexo,
    minAge: api.idade_minima,
    maxAge: api.idade_maxima,
    consent: api.consentimento,
    generateWorklist: api.gerar_worklist,
    showOnWeb: api.exibir_web,
    serviceForm: api.ficha_servico,
    schedulingForm: api.ficha_marcacao,
    deliveryProtocol: api.protocolo_entrega,
    enabled: api.habilitado,
    technique: api.tecnica,
    contrastTime: api.tempo_aplicacao_contraste,
    arrivalTime: api.tempo_chegada_paciente,
    examTime: api.tempo_exame,
    deliveryTime: api.tempo_entrega,
    enableTimeControl: api.habilita_controle_horario,
    executionSchedule: api.horario_execucao,
    maxExams: api.quantidade_maxima_exames,
    mandatoryContrastFilling: api.preenchimento_contraste_obrigatorio,
    appearsInQueue: api.aparece_fila_atendimento,
    mandatoryFilmFilling: api.preenchimento_peliculas_obrigatorio,
    allowWebScheduling: api.permitir_agendamento_web,
    isTeleconsultation: api.e_teleconsulta,
    cannotBeConfirmed: api.nao_pode_ser_confirmado,
    acceptsAnesthesia: api.aceita_anestesia,
    acceptsTriage: api.aceita_triagem,
    acceptsNursingEvolution: api.aceita_evolucao_enfermagem,
    acceptsExamRequest: api.aceita_solicitacao_exames,
    acceptsMedicalPrescription: api.aceita_prescricao_medica,
    insurance_ids: api.convenios ? api.convenios.map(c => c.id) : [],
    anamnesis_ids: api.anamneses ? api.anamneses.map(a => a.id) : [],
    service_values: processedServiceValues,
    mandatoryAnamnesis: api.anamnese_obrigatoria || false,
    anamnesisBeforeExam: api.anamnese_antes_exame || false,
    allowLaudoWithoutPrintSeries: api.permitir_laudo_sem_serie_impressao !== false, // Default true se não definido
    sigtap_codes: api.sigtap_codes || {},
    registrationInstruments: api.instrumentos_registro || [],
  };
}

// Prepara payload UI → API (COMPLETO E CORRIGIDO)
function transformUiToApi(ui) {
  // Preparar service_values no formato correto
  const serviceValues = {};
  if (ui.service_values && Object.keys(ui.service_values).length > 0) {
    Object.keys(ui.service_values).forEach(insuranceId => {
      serviceValues[insuranceId] = {
        valor: parseFloat(ui.service_values[insuranceId].value) || 0.00,
        ativo: Boolean(ui.service_values[insuranceId].enabled)
      };
    });
  }

  const payload = {
    descricao: ui.description,
    mnemonico: ui.mnemonic,
    tipo_exame: ui.examType,
    admite_coleta_material: ui.allowsMaterialCollection,
    permite_exame_complementar: ui.allowsComplementaryExam,
    preparo: ui.preparation,
    laudo: ui.reportType,
    modalidade: ui.modality,
    laudo_possui_revisao: ui.reportRevision,
    sexo: ui.gender,
    idade_minima: ui.minAge,
    idade_maxima: ui.maxAge,
    consentimento: ui.consent,
    gerar_worklist: ui.generateWorklist,
    exibir_web: ui.showOnWeb,
    ficha_servico: ui.serviceForm,
    ficha_marcacao: ui.schedulingForm,
    protocolo_entrega: ui.deliveryProtocol,
    habilitado: ui.enabled,
    tecnica: ui.technique,
    tempo_aplicacao_contraste: ui.contrastTime,
    tempo_chegada_paciente: ui.arrivalTime,
    tempo_exame: ui.examTime,
    tempo_entrega: ui.deliveryTime,
    habilita_controle_horario: ui.enableTimeControl,
    horario_execucao: ui.enableTimeControl ? ui.executionSchedule : null,
    quantidade_maxima_exames: ui.enableTimeControl ? ui.maxExams : null,
    preenchimento_contraste_obrigatorio: ui.mandatoryContrastFilling,
    aparece_fila_atendimento: ui.appearsInQueue,
    preenchimento_peliculas_obrigatorio: ui.mandatoryFilmFilling,
    permitir_agendamento_web: ui.allowWebScheduling,
    e_teleconsulta: ui.isTeleconsultation,
    nao_pode_ser_confirmado: ui.cannotBeConfirmed,
    aceita_anestesia: ui.acceptsAnesthesia,
    aceita_triagem: ui.acceptsTriage,
    aceita_evolucao_enfermagem: ui.acceptsNursingEvolution,
    aceita_solicitacao_exames: ui.acceptsExamRequest,
    aceita_prescricao_medica: ui.acceptsMedicalPrescription,
    convenio_ids: ui.insurance_ids, // Campo da aba de convênios
    anamnese_ids: ui.anamnesis_ids, // Campo da nova aba de anamneses
    anamnese_obrigatoria: ui.mandatoryAnamnesis,
    anamnese_antes_exame: ui.anamnesisBeforeExam,
    permitir_laudo_sem_serie_impressao: ui.allowLaudoWithoutPrintSeries,
    sigtap_codes: ui.sigtap_codes || {},
    instrumentos_registro: ui.registrationInstruments,
    service_values: serviceValues,
  };
  return payload;
}

const totalPages = computed(() => Math.ceil(totalCount.value / pageSize.value));

async function loadServices(page = 1) {
  isLoading.value = true;
  try {
    const params = new URLSearchParams();
    params.append('page', page);
    params.append('page_size', pageSize.value);
    if (searchQuery.value) params.append('search', searchQuery.value.trim());
    if (filterType.value) params.append('tipo_exame', filterType.value);
    if (filterModality.value) params.append('modalidade', filterModality.value);

    const { data } = await apiClient.get(`/api/v1/services/list/?${params.toString()}`);
    totalCount.value = data.count;
    currentPage.value = page;
    services.value = data.results.map(transformApiToUi);
  } catch (err) {
    console.error('Erro ao carregar serviços:', err);
  } finally {
    isLoading.value = false;
  }
}

async function saveService() {
  if (!isFormValid.value) return;
  isLoading.value = true;
  try {
    const payload = transformUiToApi(currentService.value);
    if (editMode.value) {
      await apiClient.put(`/api/v1/services/update/${currentService.value.id}/`, payload);
    } else {
      await apiClient.post('/api/v1/services/add/', payload);
    }
    showSuccessModal.value = true;
    await loadServices(currentPage.value);
  } catch (err) {
    console.error('Erro ao salvar serviço:', err);
  } finally {
    isLoading.value = false;
  }
}

async function deleteService() {
  if (!serviceToDelete.value) return;
  isLoading.value = true;
  try {
    await apiClient.delete(`/api/v1/services/delete/${serviceToDelete.value.id}/`);
    showDeleteModal.value = false;
    serviceToDelete.value = null;
    await loadServices(currentPage.value);
  } catch (err) {
    console.error('Erro ao excluir serviço:', err);
  } finally {
    isLoading.value = false;
  }
}

function openNewServiceForm() {
  currentService.value = { ...emptyService };
  editMode.value = false;
  activeTab.value = 'identification';
  currentView.value = 'form';
  insuranceSearchQuery.value = '';
  selectedAvailableInsurances.value = [];
  selectedLinkedInsurances.value = [];
  anamnesisSearchQuery.value = '';
  selectedAvailableAnamneses.value = [];
  selectedLinkedAnamneses.value = [];
}

async function editService(service) {
    isLoading.value = true;
    try {
        const { data } = await apiClient.get(`/api/v1/services/get/${service.id}/`);
        currentService.value = transformApiToUi(data);
        editMode.value = true;
        activeTab.value = 'identification';
        currentView.value = 'form';
        insuranceSearchQuery.value = '';
        selectedAvailableInsurances.value = [];
        selectedLinkedInsurances.value = [];
        anamnesisSearchQuery.value = '';
        selectedAvailableAnamneses.value = [];
        selectedLinkedAnamneses.value = [];
    } catch (err) {
        console.error('Erro ao buscar detalhes do serviço:', err);
    } finally {
        isLoading.value = false;
    }
}

// Métodos da aba de Convênios
function toggleInsuranceSelection(type, insuranceId) {
    const selectionArray = type === 'available' ? selectedAvailableInsurances : selectedLinkedInsurances;
    const index = selectionArray.value.indexOf(insuranceId);
    if (index > -1) {
        selectionArray.value.splice(index, 1);
    } else {
        selectionArray.value.push(insuranceId);
    }
}

function moveSelectedInsurancesToRight() {
    currentService.value.insurance_ids.push(...selectedAvailableInsurances.value);
    
    // Garantir que cada novo convênio tenha valores padrão
    selectedAvailableInsurances.value.forEach(insuranceId => {
        if (!currentService.value.service_values) {
            currentService.value.service_values = {};
        }
        if (!currentService.value.service_values[insuranceId]) {
            currentService.value.service_values[insuranceId] = {
                value: 0.00,
                enabled: true
            };
        }
    });
    
    selectedAvailableInsurances.value = [];
}

function moveAllInsurancesToRight() {
    const idsToMove = availableInsurances.value.map(s => s.id);
    currentService.value.insurance_ids.push(...idsToMove);
    
    // Garantir que cada novo convênio tenha valores padrão
    if (!currentService.value.service_values) {
        currentService.value.service_values = {};
    }
    idsToMove.forEach(insuranceId => {
        if (!currentService.value.service_values[insuranceId]) {
            currentService.value.service_values[insuranceId] = {
                value: 0.00,
                enabled: true
            };
        }
    });
}

function moveSelectedInsurancesToLeft() {
    currentService.value.insurance_ids = currentService.value.insurance_ids.filter(
        id => !selectedLinkedInsurances.value.includes(id)
    );
    selectedLinkedInsurances.value = [];
}

function moveAllInsurancesToLeft() {
    currentService.value.insurance_ids = [];
    selectedLinkedInsurances.value = [];
}

// Função para desvincular convênio ao clicar
function unlinkInsurance(insuranceId) {
    currentService.value.insurance_ids = currentService.value.insurance_ids.filter(
        id => id !== insuranceId
    );
    
    // Opcional: remover também os valores do serviço para este convênio
    if (currentService.value.service_values && currentService.value.service_values[insuranceId]) {
        delete currentService.value.service_values[insuranceId];
    }
}

// Métodos da aba de Anamneses
function toggleAnamnesisSelection(type, anamnesisId) {
    const selectionArray = type === 'available' ? selectedAvailableAnamneses : selectedLinkedAnamneses;
    const index = selectionArray.value.indexOf(anamnesisId);
    if (index > -1) {
        selectionArray.value.splice(index, 1);
    } else {
        selectionArray.value.push(anamnesisId);
    }
}

function moveSelectedAnamnesestoRight() {
    currentService.value.anamnesis_ids.push(...selectedAvailableAnamneses.value);
    selectedAvailableAnamneses.value = [];
}

function moveAllAnamnesestoRight() {
    const idsToMove = availableAnamneses.value.map(a => a.id);
    currentService.value.anamnesis_ids.push(...idsToMove);
}

function moveSelectedAnamnesestoLeft() {
    currentService.value.anamnesis_ids = currentService.value.anamnesis_ids.filter(
        id => !selectedLinkedAnamneses.value.includes(id)
    );
    selectedLinkedAnamneses.value = [];
}

function moveAllAnamnesestoLeft() {
    currentService.value.anamnesis_ids = [];
    selectedLinkedAnamneses.value = [];
}

function goToList() {
  currentView.value = 'list';
}

function confirmDeleteService(svc) {
  serviceToDelete.value = svc;
  showDeleteModal.value = true;
}

function resetFilters() {
  searchQuery.value = '';
  filterType.value = '';
  filterModality.value = '';
  loadServices(1);
}

function closeSuccessModal() {
  showSuccessModal.value = false;
  currentView.value = 'list';
}

// **CORREÇÃO CRÍTICA**: A propriedade computada `filteredServices` foi reintroduzida.
const filteredServices = computed(() => {
  // A filtragem agora é feita no backend, então esta propriedade apenas repassa os dados.
  // Ela é mantida para que o seu template (`v-for`) não quebre.
  return services.value;
});

const isFormValid = computed(() => {
  const s = currentService.value;
  return s.description.trim() && s.mnemonic.trim() && s.examType && s.reportType && s.modality && s.reportRevision && s.technique && s.examTime > 0 && s.deliveryTime >= 0;
});

onMounted(async () => {
  isLoading.value = true;
  await Promise.all([
      loadServices(1),
      loadAllInsurances(),
      loadAllAnamneses()
  ]);
  isLoading.value = false;
  currentView.value = 'list';
});

// --- SIGTAP: campos e helpers ---
function getSigtapCode(insuranceId, field) {
  if (!currentService.value.sigtap_codes) currentService.value.sigtap_codes = {};
  if (!currentService.value.sigtap_codes[insuranceId]) currentService.value.sigtap_codes[insuranceId] = { codigo_convenio: '', codigo_classificacao: '', cod_serv_sus: ''};
  return currentService.value.sigtap_codes[insuranceId][field] || '';
}
function setSigtapCode(insuranceId, field, value) {
  if (!currentService.value.sigtap_codes) currentService.value.sigtap_codes = {};
  if (!currentService.value.sigtap_codes[insuranceId]) currentService.value.sigtap_codes[insuranceId] = { codigo_convenio: '', codigo_classificacao: '', cod_serv_sus: ''};
  currentService.value.sigtap_codes[insuranceId][field] = value;
}

// --- Service Values: campos e helpers ---
function getServiceValue(insuranceId, field) {
  if (!currentService.value.service_values) currentService.value.service_values = {};
  if (!currentService.value.service_values[insuranceId]) currentService.value.service_values[insuranceId] = { value: 0.00, enabled: true };
  return currentService.value.service_values[insuranceId][field];
}
function setServiceValue(insuranceId, field, value) {
  if (!currentService.value.service_values) currentService.value.service_values = {};
  if (!currentService.value.service_values[insuranceId]) currentService.value.service_values[insuranceId] = { value: 0.00, enabled: true };
  currentService.value.service_values[insuranceId][field] = value;
}

// Modal de Edição de Valores do Convênio
const showEditInsuranceModal = ref(false);
const editingInsurance = ref(null);
const editForm = ref({
    value: 0.00,
    enabled: true
});

function openEditInsuranceValueModal(insurance) {
    editingInsurance.value = insurance;
    editForm.value = {
        value: getServiceValue(insurance.id, 'value'),
        enabled: getServiceValue(insurance.id, 'enabled')
    };
    showEditInsuranceModal.value = true;
}

function closeEditInsuranceModal() {
    showEditInsuranceModal.value = false;
    editingInsurance.value = null;
    editForm.value = { value: 0.00, enabled: true };
}

function saveInsuranceValueEdit() {
    if (editingInsurance.value) {
        setServiceValue(editingInsurance.value.id, 'value', editForm.value.value);
        setServiceValue(editingInsurance.value.id, 'enabled', editForm.value.enabled);
        
        // Força atualização do objeto service_values para garantir que seja detectado pelo Vue
        const insuranceId = editingInsurance.value.id;
        if (!currentService.value.service_values) {
            currentService.value.service_values = {};
        }
        currentService.value.service_values[insuranceId] = {
            value: editForm.value.value,
            enabled: editForm.value.enabled
        };
        
        closeEditInsuranceModal();
    }
}
</script>

<style>
@import 'tailwindcss/base';
@import 'tailwindcss/components';
@import 'tailwindcss/utilities';

.clinic-btn {
  background-color: var(--clinic-btn-bg);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  border: none;
  cursor: pointer;
}

.clinic-btn:hover:not(:disabled) {
  background-color: var(--clinic-btn-bg-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.clinic-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.input-font-color {
  color: var(--clinic-font-color);
}

.animate-fadeIn {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@layer base {

  /* Remove qualquer escala que venha de hover */
  button:hover {
    transform: none !important;
  }
}
</style>
